export default __webpack_public_path__ + "static/media/3031 knife block C side.1241ab8c.png";